window.Vue = require("vue");

Vue.mixin({
    methods: {
        globalFormatPrice(value) {
            if (value === 0 || value === null || value === undefined || isNaN(value)) {
                return "0";
            }

            let val = (value / 1).toFixed(0).replace(".", ",");
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        },
        globalWeightConverter(data) {
            let val = parseInt(data);
            const sum = val / 1000;
            if (val > 0) {
                if (sum < 1) {
                    return `${val} gr`;
                } else {
                    return `${sum} kg`;
                }
            } else {
                return val;
            }
        },
        globalToast(icon, title) {
            Swal.fire({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                icon: icon || "success",
                title: title || "Process successfully",
            });
        },
        globalFormatDate(date) {
            if (!date) return '';
            const d = new Date(date);
            let month = '' + (d.getMonth() + 1);
            let day = '' + d.getDate();
            const year = d.getFullYear();

            if (month.length < 2) month = '0' + month;
            if (day.length < 2) day = '0' + day;

            return [day, month, year].join('-');
        },
        globalFormatDateTime(date) {
            if (!date) return '';
            const d = new Date(date);

            let day = '' + d.getDate();
            let month = '' + (d.getMonth() + 1);
            const year = d.getFullYear();

            let hours = '' + d.getHours();
            let minutes = '' + d.getMinutes();
            let seconds = '' + d.getSeconds();

            if (day.length < 2) day = '0' + day;
            if (month.length < 2) month = '0' + month;
            if (hours.length < 2) hours = '0' + hours;
            if (minutes.length < 2) minutes = '0' + minutes;
            if (seconds.length < 2) seconds = '0' + seconds;

            return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
        },
        convertToNumber(field) {
            var cleanRp = String(this.form[`${field}_string`]).replace(/rp\./gi, '') // remove Rp.
            var cleanDot = cleanRp.replace(/\./g, '') // remove dot
            this.form[field] = parseInt(cleanDot, 10)
        },
    },
});
